import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-table-title-container',
  templateUrl: './user-table-title-container.component.html',
  styleUrls: ['./user-table-title-container.component.scss'],
  standalone: false,
})
export class UserTableTitleContainerComponent {
  @Input() titleTranslateKey: string;
}
